import React from 'react';
import BpmnJS from 'bpmn-js/dist/bpmn-modeler.production.min';

export default class Bpmn extends React.Component {

  constructor(props) {
    super(props);
    this.state = { };

    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const {
      url,
      diagramXML,
    } = this.props;


    const container = this.containerRef.current;

    this.bpmnModeler = new BpmnJS({
      container: container,
      additionalModules: [
        {
          // zoomScroll: ["value", ""],
          bendpoints: ["value", ""],
          paletteProvider: ["value", ""],
          contextPadProvider: ["value", ""],
          labelEditingProvider: ["value", ""],
        },
      ]
    });

    this.bpmnModeler.on('import.done', (event) => {
      const {
        error,
        warnings
      } = event;

      if (error) { 
        return this.handleError(error);
      }

      this.bpmnModeler.get('canvas').zoom('fit-viewport');

      return this.handleShown(warnings);
    });

    if (url) {
      return this.fetchDiagram(url);
    }

    if (diagramXML) {
      return this.displayDiagram(diagramXML);
    }
  }

  componentWillUnmount() {
    this.bpmnModeler.destroy();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      props,
      state
    } = this;

    if (props.url !== prevProps.url) {
      return this.fetchDiagram(props.url);
    }

    const currentXML = props.diagramXML || state.diagramXML;

    const previousXML = prevProps.diagramXML || prevState.diagramXML;

    if (currentXML && currentXML !== previousXML) {
      return this.displayDiagram(currentXML);
    }
  }

  displayDiagram(diagramXML) {
    this.bpmnModeler.importXML(diagramXML, (err) => {
      if (this.props.handleGetXmlForSave) {
        const pointer = this;
        this.bpmnModeler.saveXML({ format: true }, function(err, xml) {
          pointer.props.handleGetXmlForSave(xml);
        });
      }
      if (err) {
        alert("Please first select a bpmn model from BPMN Models List...");
      }
    });
  }

  fetchDiagram(url) {

    this.handleLoading();

    fetch(url)
      .then(response => response.text())
      .then(text => this.setState({ diagramXML: text }))
      .catch(err => this.handleError(err));
  }

  handleLoading() {
    const { onLoading } = this.props;

    if (onLoading) {
      onLoading();
    }
  }

  handleError(err) {
    const { onError } = this.props;

    if (onError) {
      onError(err);
    }
  }

  handleShown(warnings) {
    const { onShown } = this.props;

    if (onShown) {
      onShown(warnings);
    }
  }

  render() {
    return (
      <>
        <div style={{height: "100%"}} className="react-bpmn-diagram-container" ref={ this.containerRef }></div>
      </>
    );
  }
}